import type { CalloutBannerProps, DefaultButtonProps, IconProps, IconSize } from "@alto-avios/alto-ui";

type BoostCalloutBannerContentType = {
  items: Array<BoostCalloutBannerContent>;
};

export const parseBoostCalloutBannerContent = ({ items }: BoostCalloutBannerContentType): BoostCalloutBannerContent =>
  items[0] ?? {};

export type BoostCalloutBannerContent = {
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaUrl?: string;
  selectionMode?: "bestValue" | "bestPrice" | "multiplier";
  preferredMultiplier?: number;
  mobileLayout?: CalloutBannerProps["headerLayout"];
  tabletLayout?: CalloutBannerProps["headerLayout"];
  desktopLayout?: CalloutBannerProps["headerLayout"];
  styleVariant?: CalloutBannerProps["styleVariant"];
  emphasis?: CalloutBannerProps["emphasis"];
  buttonStyleVariant?: DefaultButtonProps["styleVariant"];
  buttonEmphasis?: DefaultButtonProps["emphasis"];
  mobileButtonSize?: DefaultButtonProps["size"];
  tabletButtonSize?: DefaultButtonProps["size"];
  desktopButtonSize?: DefaultButtonProps["size"];
  iconName?: string;
  iconPrefix?: IconProps["iconPrefix"];
  iconSize?: IconSize;
  iconColor?: IconProps["color"];
};
